import styled from 'styled-components';

export const HelpPanelContainer = styled.div`
  background: var(
    --ds-background-discovery-bold,
    var(--ds-fb-background-discovery-bold)
  );
  border-radius: 3px;
  color: var(--ds-text-inverse, var(--ds-fb-text-inverse));

  h4,
  h5 {
    color: var(--ds-text-inverse, var(--ds-fb-text-inverse));
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 16px 16px 16px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const CardContainer = styled.div`
  width: calc(100% - 16px);
  display: flex;
  flex-direction: column;
`;
